import { ApolloClient, InMemoryCache, ServerError } from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { onError } from "@apollo/client/link/error";
import { Error } from "../utils";
import {
  isHaveBeenBlocked,
  isUpgradeShow,
  publishLimitModal,
  isTrialEndedShow,
  isPremiumOnlyRestricted,
} from "../graphql/state";

const errorLink = onError(({ networkError, graphQLErrors }) => {
  graphQLErrors.forEach((error) => {
    switch (error.message) {
      case Error.PAGE_LIMIT:
        isUpgradeShow(true);
        break;

      case Error.PUBLISH_LIMIT:
        publishLimitModal(true);
        break;

      case Error.SUBSCRIPTION_REQUIRED:
        isPremiumOnlyRestricted(true);
        isTrialEndedShow(true);
        break;
    }
  });

  if (!networkError) return;

  const result = (networkError as ServerError).result;

  if ((networkError as ServerError).statusCode === 403) {
    const { origin, pathname } = window.location;
    const parts = pathname.split("/").filter(Boolean);
    const locale = parts.length > 0 ? parts[0] : "";

    window.location.href = locale ? `${origin}/${locale}/` : `${origin}/`;
    return;
  }

  if (typeof result === "object" && result !== null && "errors" in result) {
    const errors = (result as { errors: { message: string }[] }).errors;

    errors.forEach((err) => {
      if (err.message === "Your account has been blocked.") {
        isHaveBeenBlocked(true);
      }
    });
    return;
  }
  window.location.href = `${process.env.REACT_APP_ME_PAGE_URL}/login`;
});

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_ME_PAGE_URL + "/graphql",
  credentials: "include",
});

export const apolloClient = new ApolloClient({
  link: errorLink.concat(uploadLink),
  cache: new InMemoryCache(),
});
